import { QueryKey, useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
  getListingFunnelEvents,
  ListingFunnelEventsResponse,
} from 'api/admin/listing/getListingFunnelEvents'

export const listingFunnelEventsKey = (
  listingId: number,
  workerId: number,
  timeRange: { startDate: string; endDate: string }
) => ['listing-funnel-events', listingId, workerId, timeRange] as const

export const useListingFunnelEventsQuery = (
  listingId: number,
  workerId: number | null,
  timeRange: { startDate: string; endDate: string }
) => {
  return useQuery<
    ListingFunnelEventsResponse,
    AxiosError,
    ListingFunnelEventsResponse,
    QueryKey
  >({
    queryKey: listingFunnelEventsKey(listingId, workerId ?? 0, timeRange),
    queryFn: () => getListingFunnelEvents(listingId, workerId!, timeRange),
    enabled: Boolean(
      listingId && workerId && timeRange.startDate && timeRange.endDate
    ),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
